import { useGate, useUnit } from 'effector-react'
import {
  $modalAddUsers,
  $teamMap,
  $userList,
  $forbiddenDeleteUsersId,
  $modalDeleteUser,
  TeamListGate,
  UserListGate,
  getUserListFx,
  $teamsTree,
  ArticlesByUserGate,
  $userArticleList,
  getArticlesByUserIdFx,
} from './model'
import { getTeamListFx } from 'src/pages/budget/model'

export const useTeamListGate = () => useGate(TeamListGate)
export const useUserListGate = () => useGate(UserListGate)
export const useArticlesByUserGate = (userId?: string) =>
  useGate(ArticlesByUserGate, { userId })

export const useBudgetTeamList = () => {
  const teamsTree = useUnit($teamsTree)
  const loadingTeamList = useUnit(getTeamListFx.pending)

  return { teamsTree, loadingTeamList }
}

export const useBudgetUserList = () => {
  const userList = useUnit($userList)
  const loadingUserList = useUnit(getUserListFx.pending)

  return { userList, loadingUserList }
}

export const useMap = () => {
  const teamMap = useUnit($teamMap)
  const forbiddenDeleteUsersId = useUnit($forbiddenDeleteUsersId)

  return { teamMap, forbiddenDeleteUsersId }
}

export const useModalAddUserStore = () => useUnit($modalAddUsers)

export const useModalDeleteUserStore = () => useUnit($modalDeleteUser)

export const useUserArticleList = () => {
  const userArticleList = useUnit($userArticleList)
  const loadingUserArticleList = useUnit(getArticlesByUserIdFx.pending)
  return { userArticleList, loadingUserArticleList }
}
